export type ServiceArea = {
  id: string;
  number: string;
  title: string;
  titleLines: [string, string];
  tagline: string;
  sentence: string;
  highlights: string[];
  path: string;
  cta: string;
};

export const serviceAreas: ServiceArea[] = [
  {
    id: "payroll-operations",
    number: "01",
    title: "Payroll Operations",
    titleLines: ["Payroll", "Operations"],
    tagline: "Run it. Fix it. Keep it running.",
    sentence:
      "We run payroll across states and entities, step in when it breaks, and keep it covered when people leave.",
    highlights: [
      "Payroll processing",
      "Multi-state and multi-entity payroll",
      "Payroll 911 / emergency coverage",
      "Backup and continuity coverage",
      "Tax filing and registration support",
      "Fractional payroll leadership",
    ],
    path: "/payroll-operations",
    cta: "Payroll Operations",
  },
  {
    id: "hr-technology",
    number: "02",
    title: "HR Technology",
    titleLines: ["HR", "Technology"],
    tagline: "Implement it. Fix it. Make it work.",
    sentence:
      "We implement, repair, configure, and support the HRIS and payroll systems your teams rely on every day.",
    highlights: [
      "HRIS and payroll system implementations",
      "Implementation rescue",
      "Configuration review and correction",
      "Integrations",
      "Vendor conversions and migrations",
      "Ongoing system support",
    ],
    path: "/hr-technology",
    cta: "HR Technology",
  },
  {
    id: "process-controls",
    number: "03",
    title: "Process & Controls",
    titleLines: ["Process &", "Controls"],
    tagline: "Build the processes that keep payroll and HR technology working.",
    sentence:
      "We write down how the work actually gets done, put the right checks in place, and take out the manual steps.",
    highlights: [
      "SOPs and documentation",
      "Payroll calendars",
      "Approval workflows",
      "Internal controls",
      "Audit readiness",
      "Automation",
    ],
    path: "/process-controls",
    cta: "Process & Controls",
  },
];

export type ProcessGroup = { name: string; line: string; items: string[] };

export const processGroups: ProcessGroup[] = [
  {
    name: "Write it down",
    line: "So the work doesn’t live in one person’s head.",
    items: ["SOPs and documentation", "Roles and responsibilities", "Desk procedures for every cycle"],
  },
  {
    name: "Put it on a schedule",
    line: "So every deadline and approval is known in advance.",
    items: ["Payroll calendars", "Approval workflows", "Year-end and quarter-end checklists"],
  },
  {
    name: "Check it",
    line: "So mistakes are caught before employees find them.",
    items: ["Internal controls", "Reconciliations", "Audit readiness", "Business continuity"],
  },
  {
    name: "Take out the manual work",
    line: "So your team spends time on judgment, not re-keying.",
    items: ["Process redesign", "Automation", "Reporting that answers real questions"],
  },
];
